import { Getter, Setter, useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { useToastMessageState } from '../../../components/ToastMessage/ToastMessageProvider';
import { fetchCompanyPeople, hidePerson, unHidePerson } from '../../../services/queries/MaggieCompanyQueries';
import { getErrorMessage } from '../../../services/queryHelpers';
import { peopleByCompanyStateJ } from '../../../services/state/PeopleByCompanyStateJ';
import { selectedCompanyIdProfileAtom } from '../state/UIStateJ';

export const useHidePerson = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const { pushErrorToast } = useToastMessageState();

  const refresh = useCallback(
    async (_get: Getter, set: Setter) => {
      const fresh = await fetchCompanyPeople(companyId);
      set(peopleByCompanyStateJ(companyId), fresh);
    },
    [companyId]
  );

  const refreshPeople = useAtomCallback(refresh);

  const handleHidePerson = async (personId: number) => {
    try {
      await hidePerson({ companyId, personId });
      await refreshPeople();
    } catch (err) {
      pushErrorToast({ message: getErrorMessage(err, 'Failed to hide person') });
    }
  };

  const handleUnHidePerson = async (personId: number) => {
    try {
      await unHidePerson({ companyId, personId });
      await refreshPeople();
    } catch (err) {
      pushErrorToast({ message: getErrorMessage(err, 'Failed to unhide person') });
    }
  };

  return {
    handleHidePerson,
    handleUnHidePerson,
  };
};
